import { defineStore } from 'pinia'
import blockchainService from '~/services/blockchain'
import delegatesService from '~/services/delegates'
import { useSessionStore } from './session'

function toArray(value) {
  if (Array.isArray(value)) return value
  if (Array.isArray(value?.data)) return value.data
  return []
}

export const useRiseIdStore = defineStore('riseId', {
  state: () => ({
    address: null,
    owner: null,
    ramps: null,
    role: null,
    wallets: [],
    delegates: [],
  }),

  getters: {
    isOwnerARSK(state) {
      const sessionStore = useSessionStore()
      return sessionStore.wallets?.some(
        wallet => wallet.address.toLowerCase() === state.owner?.toLowerCase(),
      )
    },
  },

  actions: {
    populateData(data) {
      this.address = data?.address || null
      this.owner = data?.owner || null
      this.ramps = data?.ramps || null
      this.role = data?.role || null
      this.wallets = toArray(data?.wallets)
      this.delegates = toArray(data?.delegates)
    },

    CLEAR_STATE() {
      this.address = null
      this.owner = null
      this.ramps = null
      this.role = null
      this.wallets = []
      this.delegates = []
    },

    async getInfo() {
      const sessionStore = useSessionStore()
      if (sessionStore.riseId === 'pending' || !sessionStore.riseId) {
        this.populateData({})
        return null
      }

      try {
        const result = await blockchainService.getRiseIdData(sessionStore.riseId)
        const payload = result?.data ?? result
        if (!payload || typeof payload !== 'object') {
          this.populateData({})
          return null
        }
        this.populateData(payload)
        return payload
      }
      catch (e) {
        console.error('Failed to fetch RiseID info', e)
        this.populateData({})
        return null
      }
    },

    async getDelegates() {
      const sessionStore = useSessionStore()
      this.delegates = []
      if (sessionStore.riseId === 'pending' || !sessionStore.riseId) return []
      try {
        const result = await delegatesService.getDelegates()
        const delegates = toArray(result)
        this.delegates = delegates
        return delegates
      }
      catch (e) {
        console.error(e)
        this.delegates = []
        return []
      }
    },

    async getOwner(riseId) {
      this.owner = 'Loading'
      try {
        if (riseId === 'pending') {
          return 'Pending'
        }
        else if (riseId) {
          const result = (await blockchainService.getDynamic(`riseid/owner`))
            .data
          if (!result) return
          this.owner = result
          return result
        }
        return null
      }
      catch (e) {
        console.error(e)
        if (this.owner === 'Loading') this.owner = null
      }
    },
  },
})
